export default "__VITE_ASSET__gJBcclpX__"